import type { FaireProductEntity } from "../../entity_types/product";

export const p_gsbvb9w74h: FaireProductEntity = {
  token: "p_gsbvb9w74h",
  type: "product",
  name: "Handled Sweetgrass Tray",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/bde7a568a019ebf0184e0011c7a59c3a97f29ea689613262ba1a286706f80a35.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bcfe1c1ee2ae27492b6ed00868ea24e5af3aab7475239e9df3aaaf4bfbefc586.jpeg",
    "https://cdn.faire.com/fastly/bd38c4cdcb9d2d4136b963bd038e0a19488bd2ec2c915273827f46414fcabbbf.jpeg",
    "https://cdn.faire.com/fastly/0842169d51e378174838c2bb867d75f1716fe7487949c690790211152f3111c4.jpeg",
    "https://cdn.faire.com/fastly/c030c9cb6472562da490e2d109ea6c09d3e22d1e59df7da43bc0c63d9ed2c559.jpeg",
    "https://cdn.faire.com/fastly/66525ab8a075a64ec43bb5f943fd74776c1be7ef64cdd05f704623d13b21a088.jpeg",
    "https://cdn.faire.com/fastly/0745de6104612173667ef74ce78e40ea8494d995ad5976d99383d765087d7737.jpeg",
    "https://cdn.faire.com/fastly/891b8c703ecfea418543ca4b5955abd76d52414b26c10f7c3db56f42c7635ac3.jpeg"
  ],
  priceDollars: 21,
  description: "• Small: 12\" wide x 2.5\" deep\n• Large: 17\" wide x 3\" deep\n\nThis woven sweetgrass tray is handmade in Rwanda and makes a beautiful centerpiece on a dining room table or console. Our larger tray can be filled with fruits or decorative objects and the smaller size is a great catchall on a coffee table or console. Crafted using natural sweetgrass, the variations in tones make this basket an earthy, one-of-a-kind piece.",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:17.061Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
